"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ExpanderIcon;

var _react = _interopRequireWildcard(require("react"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var _amp = require("../_useAmpShim");

var _clsx = _interopRequireDefault(require("clsx"));

function ExpanderIcon(_ref) {
  var ExpandIcon = _ref.ExpandIcon,
      CollapseIcon = _ref.CollapseIcon,
      showExpander = _ref.showExpander,
      sublist = _ref.sublist,
      expanded = _ref.expanded;

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      classes = _useContext.classes;

  var amp = (0, _amp.useAmp)();
  ExpandIcon = ExpandIcon || _ExpandMore["default"];
  CollapseIcon = CollapseIcon || _ExpandLess["default"];
  if (!showExpander) return /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
    className: classes.icon
  });

  if (amp) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CollapseIcon, {
      className: (0, _clsx["default"])(classes.icon, classes.hidden),
      "amp-bind": "class=>rsfMenuState.sublist == '".concat(sublist, "' ? '").concat(classes.visible, " ").concat(classes.icon, "' : '").concat(classes.hidden, " ").concat(classes.icon, "'")
    }), /*#__PURE__*/_react["default"].createElement(ExpandIcon, {
      className: (0, _clsx["default"])(classes.icon, classes.visible),
      "amp-bind": "class=>rsfMenuState.sublist == '".concat(sublist, "' ? '").concat(classes.hidden, " ").concat(classes.icon, "' : '").concat(classes.visible, " ").concat(classes.icon, "'")
    }));
  } else {
    return expanded ? /*#__PURE__*/_react["default"].createElement(CollapseIcon, {
      className: classes.icon
    }) : /*#__PURE__*/_react["default"].createElement(ExpandIcon, {
      className: classes.icon
    });
  }
}
